import useIsDesktop from "@ui/utils/useIsDesktop";

export default function useViewAllLink() {
  return {
    isDesktop: useIsDesktop(),
  };
}
